import React from 'react';
import { saveAs } from 'file-saver';
import { changeMediaPrivacy } from '../../../reducers/reportsReducer';
import { useAppDispatch } from '../../../store';
import { FaDownload, FaEye, FaEyeSlash } from 'react-icons/fa';


interface UserProfileFooterTypes {
  item: any;
  reportedByName?: string;
}

const UserProfileFooter: React.FC<UserProfileFooterTypes> = ({ item, reportedByName }) => {
  const dispatch: any = useAppDispatch();

  const downloadFile = () => {
    if (item?.media?.url) {
      saveAs(item.media.url, `${Date.now()}`);
    }
  };

      
  const reportedByProfileImage = 
  item?.reportedBy?.profileImage 
 ? item?.reportedBy?.profileImage 
 : null;




  const changeMediaPrivacyFunction = async (params: { mediaId: number; privacy: number }) => {
    dispatch(changeMediaPrivacy(params));
  };

  return (
    <div className='mx-4'>
      <div className='row justify-content-center'>
        <div className='col-12 m-auto justify-content-center d-flex d-inline-block pb-2'>
          <label
            style={{ width: '100%', fontSize: '16px' }}
            htmlFor='servicename'
            className='fw-bold m-auto text-break text-center'
          >
            <span className='mx-1'>{item?.media.caption || 'N/A'}</span>
          </label>
        </div>
      </div>

      <div className='row justify-content-center pb-2'>
        <div className='col-12 m-auto justify-content-center d-flex d-inline-block'>
          <h5 key={item?.id} className='card-title badge bg-secondary text-danger fs-5 me-2'>
            {item?.reason || 'N/A'}
          </h5>
        </div>
      </div>

      
      <div className="mt-3">
            <div
                className="d-flex justify-content-center  align-items-center"
            >
                <p className={`mb-0 text-white`} style={{ fontSize: "14px", marginRight: '1rem' }}>
                    Reported By:
                </p>
                <img
                    style={{ objectFit: "contain" }}
                    height={30}
                    width={30}
                    className="me-2 rounded-circle border border-primary"
                    src={reportedByProfileImage ? reportedByProfileImage : process.env.PUBLIC_URL + "/media/avatars/blank.png"}
                    loading="lazy"
                />
                <p
                    style={{ fontSize: "12px" }}
                    className="mb-0"
                >
                    {reportedByName}
                </p>

            </div>
        </div>


      <div className={`row w-100 m-auto ${true ? 'mt-0' : 'mt-2'}`}>
        <div className='col-6 mx-auto py-2 justify-content-center d-flex'>

          <div
            className='d-flex align-items-center justify-content-center mx-4 pointer'
            onClick={downloadFile}
          >
            <FaDownload />
            <p style={{ fontSize: '16px' }} className='my-0 ms-1'>Download</p>
          </div>

          <div
            className='d-flex align-items-center justify-content-center mx-4 pointer'
            onClick={() =>
              changeMediaPrivacyFunction({
                mediaId: item?.mediaId,
                privacy: item?.media?.isAdminPrivate === 1 ? 0 : 1,
              })
            }
          >
            {item?.media.isAdminPrivate === 1 ? <FaEye /> : <FaEyeSlash />}
            <p style={{ fontSize: '14px' }} className='my-0 ms-1'>
              {item?.media?.isAdminPrivate === 1
                ? 'Reviewed - Make Public'
                : item?.media?.isAdminPrivate === 0
                  ? 'Make Private'
                  : ''}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileFooter;